import React from 'react';
//import logo from './assets/visioN.svg';
import '../App.less';
import { Layout, Menu, Row, Col } from 'antd';

const { Header } = Layout;

function WebFooter() {
  return (
    <div className="footerBG">
        <Row className="m24-t m24-b">
          <Col span={24} className="centerAlign">
            Neelank Sachan © 2021
          </Col>
        </Row>
    </div>
  );
}

export default WebFooter;